import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';
import { UserWelcomeComponent } from './user-welcome/user-welcome.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { Observable } from 'rxjs';
import { GDPRComponent } from 'src/app/pages/gdpr/gdpr.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnChanges {
  constructor(public dialog: MatDialog,
              private scroll: ViewportScroller,
              private commonService: CommonServiceService,
              private snackBar: MatSnackBar
  ) {
  }
  pageYoffset = 0;
  userEmail: any = '';
  isLoggedin = false;
  @Input() userData: any;
  isEmail = false;
  gdprChecked = false;
  totalVisitor = 0;
  @HostListener('window:scroll', ['$event']) onScroll(): void {
    this.pageYoffset = window.pageYOffset;
  }

  ngOnChanges(changes: SimpleChanges): void{
  }

  ngOnInit(): void {
  }

  scrollToTop(): void {
    this.scroll.scrollToPosition([0, 0]);
  }

  openSnackBar(message: any, action = '', isSuccess: boolean= false): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: !isSuccess ? ['primary'] : ''
  });
}

  subscribeUser(): void {
    this.gdprChecked = JSON.parse(sessionStorage.getItem('gdprConfirmation') || 'false');
    if (!this.userEmail){
      return ;
    }

    this.subscribePost();
  }

  privacyStatement(): void {
    if (!this.gdprChecked){
      const dialogRef = this.dialog.open(GDPRComponent, {
        width: '700px',
        panelClass: 'gdpr-portalDialog',
        data: {}
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      });
    }
  }

  subscribePost(): void {
    const data = {
      email: this.userEmail
    };
    if (this.userEmail.length && this.userEmail.includes('.com')){
      this.commonService.subscribeUser(data).subscribe(res => {
        if (res.success) {
          this.openSnackBar([ res?.message ? res?.message : 'Thank You For Subscribing !!'], '', true);
          this.userEmail = '';
        }else{
          this.openSnackBar(res.message);
        }
      }, (error) => {
        this.openSnackBar(error?.error?.message ? error?.error?.message : 'failed !');
      }
      );
    }
  }
  validateMethod(): void {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(this.userEmail) || !this.userEmail){
      this.isEmail = false;
    }
    else{
      this.isEmail = true;
    }
  }

}
